import React from 'react'
import OrderCardSkeleton from './OrderCardSkeleton'

interface OrdersGridSkeletonProps {
  count?: number
}

const OrdersGridSkeleton: React.FC<OrdersGridSkeletonProps> = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-5">
      {Array.from({ length: count }).map((_, index) => (
        <OrderCardSkeleton key={index} />
      ))}
    </div>
  )
}

export default OrdersGridSkeleton

